import React, {Component} from "react";
import "./AllAdminUsers.css";
import AllAdminTitleBar from "./AllAdminTitleBar/AllAdminTitleBar";
import AllAdminTable from "./AllAdminTable/AllAdminTable";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../configuration";
import axios from "axios";
import AllCustomersTable from "../AllCustomers/AllCustomersTable/AllCustomersTable";

class AllAdminUsers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: [1, 2, 3, 4],
            admins: [],
            totalItemCount: 0,
            activePage: 1,
            page: 0,
            size: ITEM_COUNT_PER_PAGE,
            searchText : "",
            searching: false
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getAllAdmins = this.getAllAdmins.bind(this);
        this.handleSearchOnChange = this.handleSearchOnChange.bind(this);
        this.searchAdmins = this.searchAdmins.bind(this);
    }

    handleSearchOnChange = (event) => {
        this.setState({
            searchText: event.target.value,
            searching: true
        }, () => this.searchAdmins())
    };

    handlePageChange = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);

        let offset = (pageNumber - 1);
        this.setState({
            page: offset,
            activePage: offset
        }, () => this.getAllAdmins(this.state.page, ITEM_COUNT_PER_PAGE));

    };

    getAllAdmins = (offset, limit) => {

        axios.get(RESOURCE_BASE_URL + 'api/admins?offset=' + offset + '&limit=' + limit)
            .then((res) => {
                this.setState({
                    admins: res.data.adminUsers,
                    totalItemCount: res.data.rowCount
                });
                // console.log("ADMIN USERS ====> ",res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    searchAdmins = () => {
        if (this.state.searchText === '') {
            this.getAllAdmins(this.state.page, ITEM_COUNT_PER_PAGE);
        } else {
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            };
            axios.get(RESOURCE_BASE_URL + 'api/admin/admins/search/' + this.state.searchText + '?offset=0&limit=5', axiosConfig)
                .then((res) => {
                    this.setState({
                        admins: res.data.admins,
                        totalItemCount: res.data.rowCount
                    });
                    // console.log("ADMINS DUO ===> ", res.data);
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
    };

    /*searchAdmins = (event) => {
        // console.log("Searching....");
        if (event.target.value === "") {
            this.getAllAdmins(0, ITEM_COUNT_PER_PAGE)
        } else {

            let resourceUrl = RESOURCE_BASE_URL + 'api/admin/admins/search/' +
                event.target.value + '?offset=' + 0 + '&limit=' + ITEM_COUNT_PER_PAGE;

            axios.get(resourceUrl)
                .then((res) => {
                    this.setState({
                        admins: res.data.admins,
                        totalItemCount: res.data.rowCount
                    });
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });
        }
    };*/

    componentDidMount() {
        this.getAllAdmins(0, ITEM_COUNT_PER_PAGE);
    }

    render() {
        return (
            <div className="admin-all-content">
                <div className="admin-all-div admin-tables-inner-padding">
                    <AllAdminTitleBar handleSearchOnChange={this.handleSearchOnChange}/>
                    <br/>
                    <div className="admin-tables-wrapper">
                    <AllAdminTable handlePageChange={this.handlePageChange}
                                   totalItemCount={this.state.totalItemCount}
                                   activePage={this.state.page+1}
                                   admins={this.state.admins}
                                   userId = {this.props.userId}
                                   getAllAdmins = {this.getAllAdmins}
                                   searching={this.state.searching}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default AllAdminUsers;



// WEBPACK FOOTER //
// ./src/components/Admin/AllAdminUsers/AllAdminUsers.js